import './styles.scss';
import '@gjensidige/core-global-css';

import React from 'react';
import ReactDOM from 'react-dom';
import { TrackingProvider } from '@gjensidige/core-analytics/lib/tracking-context';
import { CmsProvider } from '@gjensidige/service-cms';
import ErrorBoundary from '@gjensidige/service-error-boundary';

import fallBackTexts from './data/fallBackTexts.json';
import reportWebVitals from './reportWebVitals';
import tracker from './tracking';
import App from './App';
import CheckListProvider from './context/CheckListProvider';

ReactDOM.render(
  <ErrorBoundary>
    <CmsProvider
      text={{
        fileName: 'housing-check-texts',
        fallbackTexts: fallBackTexts
      }}
    >
      <CheckListProvider>
        <TrackingProvider options={tracker.getOptions()}>
          <App />
        </TrackingProvider>
      </CheckListProvider>
    </CmsProvider>
  </ErrorBoundary>,
  document.getElementById('housing-check')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
